import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PostAddIcon from '@mui/icons-material/PostAdd';
import Link from '@mui/material/Link';
import Zoom from '@mui/material/Zoom';
import { toast } from 'react-toastify';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { InvoiceModelSetup } from './InvoiceModelSetup/InvoiceModelSetup';
import { VendorLookup } from '../Lookups/VendorLookup';
import { InvoiceDocumentViewer } from '../InvoiceDocument/InvoiceDocumentViewer';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { VendorMapEditorDetailDialog } from '../VendorMap/VendorMapDetailDialog';
import { VendorMappingConfirmationDialog } from './VendorMapConfirmationDialog';
import { getFilter, setFilter, getInvoiceModuleName } from '../Common/Utilities';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export default class ManageInvoiceModel extends React.Component {
	constructor() {
		super();

		this.callsInProgress = 0;

		this.state = {
			data: [],
			openInvoiceViewer: false,
			openInvoiceModelSetupDialog: false,
			openVendorLookupDialog: false,
			rowData: null,
			invoiceDocumentSampleFileLocation: "",
			openInvoiceVendorMapDialog: false,
			invoiceViewerMode: "",
			confirmationDialog: {
				isOpen: false,
				message: '',
				title: '',
				rowData: null
			}
		};
		const userInfo = JSON.parse(localStorage.userInfo);
		this.inProgress = this.inProgress.bind(this);
		this.viewLink_clickHandler = this.viewLink_clickHandler.bind(this);
		this.invoiceModelSetupLink_clickHandler = this.invoiceModelSetupLink_clickHandler.bind(this);
		this.checkbox_clickHandler = this.checkbox_clickHandler.bind(this);
		this.newButton_clickHandler = this.newButton_clickHandler.bind(this);
		this.invoiceModelSetup_closeHandler = this.invoiceModelSetup_closeHandler.bind(this);
		this.vendorLookupLink_clickHandler = this.vendorLookupLink_clickHandler.bind(this);
		this.vendorDialog_closeHandler = this.vendorDialog_closeHandler.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.invoiceVendorMapLink_clickHandler = this.invoiceVendorMapLink_clickHandler.bind(this);
		this.invoiceVendorMap_closeHandler = this.invoiceVendorMap_closeHandler.bind(this);
		this.confirmationDialog_openHandler = this.confirmationDialog_openHandler.bind(this);
		this.confirmationDialog_closeHandler = this.confirmationDialog_closeHandler.bind(this);;

		this.mainGridRef = React.createRef();
	}

	componentDidMount() {
		const moduleName = getInvoiceModuleName(this.props.modelDefId);
		const filterText = getFilter([moduleName, "ManageInvoiceModels", "searchText"]) || '';
		const sortModel = getFilter([moduleName, "ManageInvoiceModels", "sortModel"]) || [];

		this.setState({ filterText, sortModel }, () => {
			this.fetchInvoiceModels();
			const gridRef = this.mainGridRef?.current;
			if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
				gridRef.setQuickFilterValues([this.state.filterText]);
			}
		});
	}

	inProgress(value, uploading, loaded, invoiceDocumentSampleFileLocation) {
		if (!uploading) {
			if (value === true) {
				this.callsInProgress++;
			}
			else if (value === false) {
				if (this.callsInProgress > 0) {
					this.callsInProgress--;
				}

				if (this.callsInProgress === 0) {
					if (invoiceDocumentSampleFileLocation) {
						this.setState({ invoiceDocumentSampleFileLocation: invoiceDocumentSampleFileLocation });
					}
				}
			}
		}

		return this.props.inProgress(value, uploading, loaded);
	}

	fetchInvoiceModels() {
		var that = this;
		var modelDefId = this.props.modelDefId;

		this.props.inProgress(true);

		httpGet('/api/invoicemodels/' + modelDefId)
			.then((response) => {
				var data = response.data;

				var rowId = 1;
				data.map(row => row.rowId = rowId++);

				this.props.inProgress(false);
				that.setState({data: data });
			})
			.catch((error) => {
				this.props.inProgress(false);

				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}

	newButton_clickHandler(event) {
		this.setState({ openInvoiceModelSetupDialog: true, mode: "NewSample", rowData: null });
	}

	checkbox_clickHandler(event) {
		var rowData = this.getRowData(parseInt(event.target.value, 10));
		var _rowData = structuredClone(rowData);
		_rowData.documentModelIsActive = event.target.checked ? 'Y' : 'N';
		_rowData.versionId = (_rowData.type === 'Vendor Map' && _rowData?.documentModelNameTag?.replace('v', '')) || null;

		if (!rowData.vendor) {
				toast.error(<div>Error: model cannot be set active without vendor<br /></div>);
			return;
		}
		
		this.props.inProgress(true);

		httpPost("/api/invoicemodels/", _rowData)
			.then((response) => {

				var result = response.data;
				var dbResponse = result?.records?.dbResponse;
				if (dbResponse?.errorCode !== -1) {
					toast.success('Updated Successfully');
				}
				else {
					toast.error(<div>{dbResponse.errorMessage }</div>);
				}

				this.props.inProgress(false);


				this.fetchInvoiceModels();
			}).catch((error) => {
				this.props.inProgress(false);
				toast.error(<div>Invoices Update Failed<br />{error.response.data}</div>);
			});
	}

	viewLink_clickHandler(event) {
		event.preventDefault();

		var rowData = this.getRowData(parseInt(event.target.dataset.rowid, 10));
		var invoiceViewerMode = rowData?.type === 'Vendor Map' ? 'Vendor Map' : '';

		this.setState({
			openInvoiceViewer: true,
			invoiceDocumentFileLocation: rowData.invoiceDocumentFileLocation,
			invoiceViewerMode: invoiceViewerMode
		});
	}

	invoiceModelSetupLink_clickHandler(event) {
		event.preventDefault();

		var rowData = this.getRowData(parseInt(event.target.dataset.rowid, 10));
		rowData.mode = event.target?.dataset?.mode ||'';
		this.setState({  openInvoiceModelSetupDialog: true, mode: event.target.dataset.mode, rowData: rowData });
	}
	invoiceVendorMapLink_clickHandler(event) {
		event.preventDefault();

		var rowData = this.getRowData(parseInt(event.target.dataset.rowid, 10));
		this.setState({ openInvoiceVendorMapDialog: true, mode: event.target.dataset.mode, rowData: rowData });
	}

	invoiceModelSetup_closeHandler(event) {
		this.setState({  openInvoiceModelSetupDialog: false });

		this.fetchInvoiceModels();
	}
	invoiceVendorMap_closeHandler(event) {
		this.setState({ openInvoiceVendorMapDialog: false });

		this.fetchInvoiceModels();
	}

	vendorLookupLink_clickHandler(event) {
		event.preventDefault();

		var rowData = this.getRowData(parseInt(event.target.dataset.rowid, 10));

		this.setState({ openVendorLookupDialog: true, mode: event.target.dataset.mode, rowData: rowData });
	}

	vendorDialog_closeHandler(event, vendor) {
		var rowData = this.state.rowData;
		var saveVendor = vendor && (rowData.vendorCode !== vendor.vendorCode || rowData.siteId !== vendor.siteId);

		this.setState({  openVendorLookupDialog: false });

		if (saveVendor) {
			rowData.vendorCode = vendor.vendorCode;
			rowData.siteId = vendor.siteId;

			this.props.inProgress(true);

			httpPost("/api/invoicemodels/", rowData)
				.then((response) => {
					this.props.inProgress(false);

					toast.success('Updated Successfully');

					this.fetchInvoiceModels();
				}).catch((error) => {
					this.props.inProgress(false);
					toast.error(<div>Invoices Update Failed<br />{error.response.data}</div>);
				});
		}
		else {
			this.props.inProgress(false);
		}
	}

	closeDialog(event) {
		this.setState({
			openInvoiceViewer: false,
			invoiceViewerMode: ""
		});
	}

	getRowData(value) {
		var rowData = this.state.data;
		return rowData[rowData.findIndex(d => d.rowId === value)];
	}

	displayActions(rowData) {
		let isVendorMap = rowData.type === 'Vendor Map';
		let version = rowData.documentModelNameTag?.replace('v', '');
		version = isNaN(version) ? 0 : parseInt(version);
		let viewLink = isVendorMap ? <Link data-rowid={rowData.rowId} href="#" data-mode="View" onClick={this.invoiceVendorMapLink_clickHandler}>View</Link> :
			<Link data-rowid={rowData.rowId} href="#" data-mode="View" onClick={this.invoiceModelSetupLink_clickHandler}>View</Link>
		switch (rowData.action) {
			case 1:
				return <div>
					<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / <Link data-rowid={rowData.rowId} data-mode="New" href="#" onClick={this.invoiceModelSetupLink_clickHandler}>New</Link>
				</div>;
			case 2:
				return <div>
					<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode="VendorLookup" onClick={this.vendorLookupLink_clickHandler}>Assign Vendor</Link>
					
				</div>;
			case 3:
				return (isVendorMap ?
					<div>
						<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode={version>1 ? 'Copy' : "Map Vendor"} onClick={this.invoiceVendorMapLink_clickHandler}>Map Vendor</Link>
					</div>
				:
				<div>
						<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode="Edit" onClick={this.invoiceModelSetupLink_clickHandler}>Edit</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode="Copy" onClick={this.invoiceModelSetupLink_clickHandler}>Copy</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode="VendorLookup" onClick={this.vendorLookupLink_clickHandler}>Assign Vendor</Link>
				</div>);
			case 4:
				return (isVendorMap ?
					<div>
						<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / {viewLink} /  <Link data-rowid={rowData.rowId} href="#" data-mode="Copy" onClick={this.confirmationDialog_openHandler}>Revise</Link>
					</div>
					:
					<div>
						<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode="Edit" onClick={this.invoiceModelSetupLink_clickHandler}>Edit</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode="Copy" onClick={this.invoiceModelSetupLink_clickHandler}>Copy</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode="VendorLookup" onClick={this.vendorLookupLink_clickHandler}>Reassign Vendor</Link>
				</div>);
			case 5:
				return (isVendorMap ?
					<div>
						<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / {viewLink} / <Link data-rowid={rowData.rowId} href="#" data-mode="Copy" onClick={this.confirmationDialog_openHandler}>Revise</Link>
					</div>
					: <div>
						<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / {viewLink} /  <Link data-rowid={rowData.rowId} href="#" data-mode="Copy" onClick={this.invoiceModelSetupLink_clickHandler}>Copy</Link>
				</div>);
			case 6:
				return <div>
					<Link data-rowid={rowData.rowId} href="#" data-mode="ViewInvoice" onClick={this.viewLink_clickHandler}>View Invoice</Link> / <Link data-rowid={rowData.rowId} href="#" data-mode={version > 1 ? 'Copy' : "Map Vendor"} onClick={this.invoiceVendorMapLink_clickHandler}>Map Vendor</Link>
				</div>;
			default:
				return <div>Unknown</div>;
		}
	}
	confirmationDialog_closeHandler = (event) => {
		
		if (event.response === 'Y') {
			let rowData = this.state.confirmationDialog.rowData;
			rowData = structuredClone(rowData);
			rowData.versionId = rowData?.documentModelNameTag?.replace('v', '') || null;
			this.props.inProgress(true);
			httpPost("/api/InvoiceDocument/revisedocumentvendormapping/", rowData)
				.then((response) => {
					this.props.inProgress(false);
					var result = response.data;
					var dbResponse = result.dbResponse;
					//toast.success('New Revision Created Successfully');
					if (dbResponse?.errorCode !== -1) {
						rowData.revisionId = response?.data?.versionId;
						rowData.documentModelNameTag = 'v' + (response?.data?.versionId || '')
						toast.success('New Revsion Created Successfully');
						this.setState({ openInvoiceVendorMapDialog: true, mode: 'Copy', rowData: rowData });
					}
					else {
						let errorMessage = dbResponse?.errorMessage;
						toast.error(<div>{ errorMessage}</div>);
					}
				
				})
				.catch((xhr) => {
					this.props.inProgress(false);
					toast.error(xhr + ' Revsion Creation Failed');
				});
		}
		this.setState({
			...this.state, confirmationDialog: {
				isOpen: false,
				title: '',
				message: '',
				rowData: null
			}
		});
	}
	confirmationDialog_openHandler =(event) => {
		let message = 'This action will create a new revision. Do you want to continue?';
		event.preventDefault();
		var rowData = this.getRowData(parseInt(event.target.dataset.rowid, 10));
		this.setState({
			...this.state, confirmationDialog: {
				isOpen: true,
				title: 'Revise',
				message: message,
				rowData: rowData
			}
		});
	}

	render() {
		const info = {
			rowData: this.state.rowData,
			mode: this.state.mode,
			inProgress: this.inProgress,
			modelDefId: this.props.modelDefId,
			invoiceDocumentSampleFileLocation: this.state.invoiceDocumentSampleFileLocation
		}
		const vendorMapDetailInfo = {
			mode: this.state.mode,
			inProgress: this.inProgress,
			modelDefId: this.props.modelDefId,
			invoiceDocument: { ...this.state.rowData, revisionId: this.state.rowData?.documentModelNameTag?.replace('v', '') || null, invoiceDocumentFileLocation: this.state?.rowData?.invoiceDocumentSampleFileLocation },
		}

		const vendorInfo = {
			openDialog: this.state.openVendorLookupDialog,
			invoiceModel: {
				vendorCode: this.state.rowData ? this.state.rowData.vendorCode : null,
				siteId: this.state.rowData ? this.state.rowData.siteId : null
			},
			inProgress: this.props.inProgress,
			mode: this.state.mode
		}

		const invoiceViewerInfo = {
			inProgress: this.props.inProgress,
			modelDefId: this.props.modelDefId,
			invoiceDocumentFileLocation: this.state.invoiceDocumentFileLocation,
			mode: this.state.invoiceViewerMode,
			onClose: this.closeDialog
		}

		const clientInfo = {
			rowData: this.state.rowData,
			mode: this.state.mode,
			inProgress: this.inProgress,
			modelDefId: this.props.modelDefId
		}

		return (
			<div>
				<h1>Manage {this.props.modelDefId === 1 ? 'Media' : (this.props.modelDefId === 2 ? 'Production' : 'Broadcast') } Invoice Models</h1>
				<div className="form-group">
					
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							gridRef={this.mainGridRef}
							setFilterText={(text) => {
								const trimmed = text?.trim() || '';
								this.setState({ filterText: trimmed });

								setFilter([getInvoiceModuleName(this.props.modelDefId), "ManageInvoiceModels", "searchText"], trimmed);
								
							}}
							highlightSearchTextOnMainScreenGrid={true}
							onSortModelChange={(model) => {
								this.setState({ sortModel: model });
								setFilter([getInvoiceModuleName(this.props.modelDefId), "ManageInvoiceModels", "sortModel"], model);
							}}
							sortModel={this.state.sortModel}
							columns={[
								{
									headerName: 'ID',
									field: 'id',
									width: 100
								},
								{
									headerName: 'Model Name',
									field: 'displayModelName',
									width: 140,
									flex:0.8
								},
								{
									headerName: 'Model Tag',
									field: 'documentModelNameTag',
									flex:1
								},
								{
									headerName: 'Type',
									field: 'type',
									flex:1
								},
								{
									headerName: 'Model Status',
									field: 'modelStatus',
									flex:1
								},
								{
									headerName: 'Active',
									field: 'documentModelIsActive',
									headerStyle: {
										textAlign: 'left',
									},
									width: 100,
									renderCell: rowData =>
										<Checkbox
											color="default"
											checked={rowData.row.documentModelIsActive === 'Y'}
											name={"documentModelIsActive" + rowData.row.id}
											//disabled={(rowData.row.type !== 'Vendor Map' && rowData.row.vendor.length === 0)}
											value={rowData.row.rowId}
											style={{ display: rowData.row.action === 1 ? "none" : "" }}
											onClick={this.checkbox_clickHandler}
										/>
								},
								{
									headerName: 'ERP Vendor',
									field: 'vendor',
									flex:1
								},
								{
									headerName: 'ERP Vendor Site',
									field: 'siteId',
									width: 140,
									flex:1
								},
								{
									headerName: 'Actions',
									field: 'actions',
									align: 'center',
									headerAlign:'center',
									width: 230,
									headerStyle: {
										textAlign: 'center',
									},
									cellStyle: {
										textAlign: 'center'
									},
									flex:1,
									renderCell: rowData => this.displayActions(rowData.row)
								}

							]}
							customcomponent={<Button
								variant="contained"
								color="inherit"
								onClick={this.newButton_clickHandler}
								size="medium"
								style={{ float: "right", zIndex: 1, marginRight: 10, marginTop:-2 }}
								startIcon={<PostAddIcon />}>New Model</Button> }
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
					
				</div>
				<Dialog
					open={this.state.openInvoiceViewer}
					aria-labelledby="draggable-dialog-title"
					TransitionComponent={Transition}
					fullWidth={true}
					maxWidth="lg"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Invoice Document
					</DialogTitle>
					<DialogContent>
						<InvoiceDocumentViewer info={invoiceViewerInfo} />
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={this.closeDialog} color="primary">
							Close
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog fullScreen open={this.state.openInvoiceModelSetupDialog} TransitionComponent={Transition}>
					<InvoiceModelSetup info={info} onClose={this.invoiceModelSetup_closeHandler} />
				</Dialog>
				<VendorLookup info={vendorInfo} onClose={this.vendorDialog_closeHandler} />
				<VendorMapEditorDetailDialog isOpen={this.state.openInvoiceVendorMapDialog}
					forceVendorMapPrompt={false}
					TransitionComponent={Transition}
					info={vendorMapDetailInfo}
					clientInfo={clientInfo}
					onClose={this.invoiceVendorMap_closeHandler}
				></VendorMapEditorDetailDialog>
				<VendorMappingConfirmationDialog
					{...this.state.confirmationDialog}
					onClose={this.confirmationDialog_closeHandler}
				/>
			</div>
		);
	}
}
